import { getSmallestProductPictureFormat } from '@/modules/pictures/helpers/getSmallestProductPictureFormat';
import { type ProductBySlugResponse } from '@/modules/product/aliases';
import {
  hasThumbnailFormats,
  toProductPicture,
  toProductVideo,
} from '@/modules/product/helpers/toProductMedia';

export function getSmallestProductPictureOrVideoFormat(
  productBasic: ProductBySlugResponse
) {
  const firstPicture = productBasic.pictures?.[0];
  if (firstPicture) {
    return getSmallestProductPictureFormat(
      toProductPicture(firstPicture).formats
    );
  }

  const firstVideo = productBasic.videos?.[0];
  const video = firstVideo ? toProductVideo(firstVideo) : undefined;
  if (video && hasThumbnailFormats(video)) {
    return getSmallestProductPictureFormat(video.thumbnail.formats);
  }

  return null;
}
